import env from './env';

const EDW_CONST = {
    ...env,
    
    METHOD: 'GET',

    //End points
    ASSESSMENT_END_POINT: 'assessment/v1',
    TOPIC: 'topic',
    SKILL: 'skill',
    OBJECTIVE: 'objective',
    QUESTION: 'question',
    TABLE_VIEW: 'Table view',
    GRAPH_VIEW: 'Graph view',
    STUDENT_END_POINT: 'student/v1',
    COMMON_END_POINT: 'common/v1',
    MONTHS: { '01': 'Jan', '02': 'Feb', '03': 'Mar', '04': 'Apr', '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Aug', '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec', },
    GROUP_END_POINT:'groups/v1',
    LOW_PERCENTGE:35,
    AVG_PERCENTAGE:70,
    GOOD_PERCENTAGE:100,
    DUPLICATE_YEAR_ERR_MSG: "To see a year average, please ensure all of your students are in the same year group.",
    ERROR_MSG: "There is a problem loading the data.",
    STU_BELOW_EMPTY_MSG:"There are no students requiring your attention currently."
}

export default EDW_CONST;

